// @vendors
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { UserIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next';

// @types
import { ServiceRequestResponse } from '../../../../types/request.types';

const ActiveServices: React.FC<{ activeServices: ServiceRequestResponse | null }> = ({ activeServices }) => {
    const { t } = useTranslation();

    return (
        <div className="w-full 2xl:w-[45rem] overflow-auto h-[290px]">
            <h3 className="text-xl text-center font-semibold mb-3 dark:text-dark-cText">
                {t("professional.dashboard.activeService")}
            </h3>
            <div className="space-y-2">
                {activeServices?.items?.length
                    ? activeServices?.items.map((item, index) => (
                        <div
                            key={item.serviceRequestId}
                            className="flex flex-col md:flex-row items-center justify-between border border-cBorder px-4 py-2 rounded-2xl"
                        >
                            <div className="flex items-center space-x-4">
                                <div className="rounded-[22%] bg-[#0202] dark:bg-gray-800 p-2">
                                    <UserIcon className="size-7 text-textBrand" />
                                </div>
                                <div>
                                    <p className="font-semibold dark:text-dark-cText/90 text-[15px]">
                                        {`${item?.customer?.names || ""} ${item?.customer?.lastNames || ""}`.trim()}
                                    </p>
                                    {item?.services?.length
                                        ? item?.services.map((x) => (
                                            <p key={item.serviceRequestId} className="text-sm text-cTextSecondary dark:text-dark-cText/60">
                                                {x?.name || 'Sin servicio'}.
                                            </p>
                                        ))
                                        : null
                                    }
                                    <p className="text-xs text-gray-500 dark:text-dark-cText/50">
                                        {new Date(item.customer.createdAt).toLocaleDateString()}
                                    </p>
                                </div>
                            </div>
                            <span className="flex flex-row gap-2 items-center bg-[#E2F0EC] text-[#83B2A3] text-xs font-medium p-2 rounded-xl border border-cBorder">
                                <CheckCircleIcon className="size-6 text-[#83B2A3]" />
                                {t("professional.dashboard.attending")}
                            </span>
                        </div>
                    ))
                    : <div className="w-full flex items-center justify-center mt-[30px] text-[15px] text-[#848484] dark:text-dark-cText/60 border border-cBorder px-4 py-4 rounded-2xl">
                        {t("professional.dashboard.withoutServices")}
                    </div>}
            </div>
        </div>
    )
}

export default ActiveServices